import { call, select } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';
import { selectVirtualBackgrounds } from 'features/virtual-backgrounds/selectors';
import { VirtualBackgroundItem, VirtualBackgroundType } from 'features/virtual-backgrounds/types';
import { sdkVirtualBackgroundChangedEventRequested } from 'features/sdk/actions';

// @TODO ideally this saga should be called upon updating the VB state in the store, not from the VB class
// after refactoring, we will have an access to the selected background from the store so that we use an accurate data
export function* virtualBackgroundChangedEventSaga(
  action: ReturnType<typeof sdkVirtualBackgroundChangedEventRequested>
) {
  const appBackgrounds: VirtualBackgroundItem[] = yield select(selectVirtualBackgrounds);

  // Map a virtual background type from the external service to the format used in the application
  const backgroundConfig = action.payload;
  const matchedBackground = appBackgrounds.find(
    (bg) => bg.type === backgroundConfig.type && bg.value === backgroundConfig.value
  );

  let virtualBackgroundToSend;

  if (matchedBackground) {
    virtualBackgroundToSend = matchedBackground;
  } else {
    // No match in predefined backgrounds indicates this is a custom background
    virtualBackgroundToSend = {
      id: '',
      type: backgroundConfig.type as VirtualBackgroundType,
      value: backgroundConfig.value,
      thumbnail: '',
      label: '',
    };
  }

  yield call(eventBus.sendMessage, 'virtualBackgroundChanged', {
    virtualBackground: virtualBackgroundToSend,
  });
}
